
$(document).ready(function(){ 
	 $('.s2sldr').slick({
		autoplay: true,
		dots: true,	
		arrows: false,
		adaptiveHeight: false,
		fade: false,
		focusOnSelect: false,
		slidesToScroll: 1,
		slidesToShow: 6,
			responsive: [
			{
			  breakpoint: 1800,
			  settings: {
				slidesToShow: 5,
				slidesToScroll: 1,
				dots: true,
			  }
			},		
			{
			  breakpoint: 1500,
			  settings: {
				slidesToShow: 4,
				slidesToScroll: 1,
				dots: true,
			  }
			},			 
			{
			  breakpoint: 1030,
			  settings: {
				slidesToShow: 3,
				slidesToScroll: 1,
				dots: true,
			  }
			},
			{
			  breakpoint: 767,
			  settings: {
				centerMode: true,
			    centerPadding: '46px',
			    slidesToShow: 1,
				slidesToScroll: 1,
				adaptiveHeight: false,
				dots: true,			    
			  }
			}
		  ]
		
	});
	  
	 	$('.accordion1-header').click(function () {

			var item = $(this).parent('.accordion1-item');
			var content = item.find('.accordion1-content');
	
			// Toggle only the clicked accordion
			item.toggleClass('active');
	
			content.stop(true, true).slideToggle(300);
		});
		
		$('.accordion-header').click(function () {

			var item = $(this).parent('.accordion-item');
			var content = item.find('.accordion-content');
	
			// Toggle only the clicked accordion
			item.toggleClass('active');
	
			content.stop(true, true).slideToggle(300);
		});
		  
	  /*----------------------------*/
	  $('.slider').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: true,
		fade: false,
		dots: false,
		asNavFor: '.slider-nav-thumbnails',
	 });
	
	 $('.slider-nav-thumbnails').slick({
		slidesToShow: 5,
		slidesToScroll: 1,
		asNavFor: '.slider',
		dots: false,
		focusOnSelect: true,
		arrows: false,
	 });
	
	 // Remove active class from all thumbnail slides
	 $('.slider-nav-thumbnails .slick-slide').removeClass('slick-active');
	
	 // Set active class to first thumbnail slides
	 $('.slider-nav-thumbnails .slick-slide').eq(0).addClass('slick-active');
	
	 // On before slide change match active thumbnail to current slide
	 $('.slider').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
		var mySlideNumber = nextSlide;
		$('.slider-nav-thumbnails .slick-slide').removeClass('slick-active');
		$('.slider-nav-thumbnails .slick-slide').eq(mySlideNumber).addClass('slick-active');
	 });
	 
	 /*-------------------*/
	 var totalSeconds = 5 * 3600 + 49 * 60 + 23;

	  function padZero(number) {
		return number < 10 ? '0' + number : number;
	  }
	
	  function updateTimer() {
		if (totalSeconds < 0) {
		  clearInterval(timerInterval);
		  return;
		}
	
		var hrs = Math.floor(totalSeconds / 3600);
		var mins = Math.floor((totalSeconds % 3600) / 60);
		var secs = totalSeconds % 60;
	
		$('.hours').text(padZero(hrs));
		$('.minutes').text(padZero(mins));
		$('.seconds').text(padZero(secs));
	
		totalSeconds--;
	  }
	
	  // Run timer every second
	  var timerInterval = setInterval(updateTimer, 1000);
});
/*--------------------*/
	
	$(document).ready(function () {

    var stickyGap = 0;

    $('.s3bx').each(function () {

        var $left = $(this).children('.s3lft').first();

        if (!$left.length) {
            return;
        }

        if (!$left.next('.s3lft-placeholder').length) {

            $('<div class="s3lft-placeholder"></div>')
                .insertAfter($left);

        }

    });

    function adjustFixedDiv() {

        var scrollTop = $(window).scrollTop();
        var windowWidth = $(window).width();


        $('.s3bx').each(function () {

            var $box = $(this);

            var $left = $box.children('.s3lft').first();
            var $right = $box.children('.s3rgt').first();
            var $placeholder =
                $box.children('.s3lft-placeholder').first();


            if (
                !$left.length ||
                !$right.length ||
                !$placeholder.length
            ) {
                return;
            }

            if (windowWidth <= 767) {

                $placeholder.hide();

                $left
                    .removeClass('posfixed')
                    .addClass('position')
                    .css({
                        position: '',
                        top: '',
                        left: '',
                        width: ''
                    });

                return;
            }

            $left
                .removeClass('posfixed')
                .addClass('position')
                .css({
                    position: '',
                    top: '',
                    left: '',
                    width: ''
                });

            $placeholder.hide();

            var boxOffset = $box.offset();

            var boxTop = boxOffset.top;

            var boxHeight = $box.outerHeight();

            var boxBottom = boxTop + boxHeight;

            var leftOffset = $left.offset();

            var leftTop = leftOffset.top;
            var leftLeft = leftOffset.left;

            var leftWidth = $left.outerWidth();
            var leftHeight = $left.outerHeight();

            var rightOffset = $right.offset();

            var rightTop = rightOffset.top;
            var rightHeight = $right.outerHeight();

            var rightBottom =
                rightTop + rightHeight;

            if (scrollTop < boxTop) {

                return;
            }

            var maxScroll =
                rightBottom -
                leftHeight -
                stickyGap;

            if (scrollTop < maxScroll) {

                $placeholder
                    .show()
                    .css({
                        width: leftWidth + 'px',
                        height: leftHeight + 'px'
                    });


                $left
                    .removeClass('position')
                    .addClass('posfixed')
                    .css({
                        position: 'fixed',
                        top: '0px',
                        left: leftLeft + 'px',
                        width: leftWidth + 'px'
                    });

                return;
            }

            var bottomTop =
                rightBottom -
                boxTop -
                leftHeight -
                stickyGap;


            $left
                .removeClass('posfixed')
                .addClass('position')
                .css({
                    position: 'absolute',
                    top: bottomTop + 'px',
                    left: '',
                    width: leftWidth + 'px'
                });


            $placeholder
                .show()
                .css({
                    width: leftWidth + 'px',
                    height: leftHeight + 'px'
                });

        });

    }

    $(window).on('scroll', function () {

        adjustFixedDiv();

    });

    $(window).on('resize', function () {

        $('.s3lft').each(function () {

            $(this)
                .removeClass('posfixed')
                .addClass('position')
                .css({
                    position: '',
                    top: '',
                    left: '',
                    width: ''
                });

        });

        $('.s3lft-placeholder').hide();

        adjustFixedDiv();

    });

    adjustFixedDiv();

});
